<!--
 * @Description:
 * @Author: 诺
 * @Date: 2022-04-19 11:52:34
 * @LastEditors: 诺
 * @LastEditTime: 2022-11-03 20:55:54
-->
<template>
  <div
    id="boxMian"
    v-if="configInfo"
    class="boxMian"
    :style="{
      backgroundColor: configInfo.backgroundColour,
    }"
  >
    <div class="page-wrapper" :style="{ backgroundImage: `url('${configInfo.bg2}')` }">
      <div class="kv"><img :src="configInfo.kv2" /></div>
      <div class="landmarkList" id="landmarkList">
        <div class="landmarkItem" :id="'landmarkItem' + item.requireLevel" :style="{ zIndex: landmarkList.length - index, justifyContent: item.buttonPosition == 2 ? 'flex-end' : item.buttonPosition == 1 ? 'flex-start' : 'center' }" v-for="(item, index) in landmarkList" :key="index">
          <img class="icon iconImg" v-if="item.requireLevel <= assistanceNumber" :src="item.img" />
          <img class="icon" v-else :src="item.greyImg" />
          <div class="buttonPosition">
            <div class="success" v-if="item.requireLevel <= site.requireLevel" :style="{ backgroundColor: rgba(configInfo.mainColour, 0.8) }">{{ item.name }}</div>
            <div class="name" v-else-if="item.requireLevel == nextSite.requireLevel" :style="{ backgroundColor: rgba(configInfo.backgroundColour, 0.8) }">
              再找{{ item.lackNum }}个好友帮忙<br />点亮"{{ item.name }}"
              <div class="jt" :style="{ backgroundColor: rgba(configInfo.backgroundColour, 0.8) }"></div>
            </div>
            <div class="iconList">
              <template v-for="(avatarItem, index) in item.userList">
                <img :class="['avatar', avatarItem.type == 'def' ? 'def' : '']" :key="index" :src="avatarItem.headImgUrl" />
              </template>
              <!-- 更多头像 当前需要的大于7才显示 最多显示6个用户头像 -->
              <div :class="item.requireLevel <= assistanceNumber ? 'more2' : 'more'" :style="{ background: item.requireLevel <= assistanceNumber ? configInfo.buttonBackgroundColour : '#617086' }" v-if="item.require > 7">···</div>
              <!-- 当前是否可以抽取奖品 -->
              <div class="prizeIcon" v-if="item.lotteryTimesInit > item.userLotteryCount && item.requireLevel <= assistanceNumber && item.prizeCount != 0" @click="goLuck(item)">
                <div class="anima"></div>
                <img class="icon" src="https://assets.rurushishi.com/activies/activityCenter/lightup/avatar.png" />
                <img v-if="index == landmarkList.length - 1 && item.userLotteryCount == 0" :class="['tipImg', 'animate-click']" src="https://assets.rurushishi.com/activies/activityCenter/turntableLottery/tip.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ActBaseBtnHome :bColor="configInfo.buttonBackgroundColour" :textColor="configInfo.buttonTextColour"></ActBaseBtnHome>

    <div v-if="!nextSite" class="ActBaseBottom" :style="bgStyle">
      <div class="success">
        恭喜！您已点亮全部站点
        <div class="more-txt" v-if="configInfo.bonusSwitch == 1">奖金池大奖等您瓜分！</div>
      </div>
    </div>
    <div class="ActBaseBottom" ref="box" :style="bgStyle" v-else>
      <div
        class="default act-text-stroke"
        @click="showShare"
        :style="{
          backgroundColor: configInfo.buttonBackgroundColour,
          color: configInfo.buttonTextColour,
        }"
      >
        我要点亮
      </div>
      {{ configInfo.disclaimer || "本次活动最终解释权归开发商所有。" }}
    </div>
  </div>
</template>

<script>
import Vue from "vue/dist/vue.js";
import soundBuffer from "@/utils/sound";
import util from "./../../utils/common";

export default {
  components: {},
  props: {},
  data() {
    return {
      configInfo: null, //配置信息
      landmarkList: [],
      assistanceNumber: 0,
      userList: [],
      prizeInfo: {},
      site: {},
      nextSite: {},
      num: 0,
      soundBuf: null,
      gameCount: 0,
      alertFrom: null,
    };
  },

  filters: {
    filterName: function (name) {
      if (name == null) {
        return name + "***";
      } else if (name && name.length >= 1) {
        return name.slice(0, 2) + "***";
      } else {
        return name + "***";
      }
    },
  },
  watch: {},
  computed: {
    bgStyle() {
      const { backgroundColour } = this.configInfo;
      return {
        background: `linear-gradient(180deg, ${backgroundColour}00 0%, ${backgroundColour} 100%)`,
      };
    },
    progressStyle() {
      const { buttonBackgroundColour } = this.configInfo;
      return {
        background: `linear-gradient(90deg, #21FFF0 0%, ${buttonBackgroundColour} 100%)`,
      };
    },
    progressBgStyle() {
      const { mainColour } = this.configInfo;
      return {
        background: `linear-gradient(180deg, ${mainColour} 0%, rgba(255, 255, 255, 0.6) 100%)`,
      };
    },
  },
  async mounted() {
    console.log(this.$actCode);
    this.configInfo = this.$configInfo;
    await this.getAssistanceUser();
    await this.getAssistanceNumber();
    await this.initSite();
    document.title = this.$configInfo.actName;
    if (this.$configInfo.shareSwitch!= 1) {
      this.$wx.hideOptionMenu();
    }
  },

  methods: {
    async initSite() {
      let url = this.$apizt.action.getSite;
      const { data, result } = await this.$httpzt.requestRestFul(url, {});
      if (result) {
        let requireLevel = 0;
        let list = [];
        console.log(data);

        const defaultList = [
          { headImgUrl: "https://assets.rurushishi.com/activies/activityCenter/lightup/default.png", type: "def" },
          { headImgUrl: "https://assets.rurushishi.com/activies/activityCenter/lightup/default.png", type: "def" },
          { headImgUrl: "https://assets.rurushishi.com/activies/activityCenter/lightup/default.png", type: "def" },
          { headImgUrl: "https://assets.rurushishi.com/activies/activityCenter/lightup/default.png", type: "def" },
          { headImgUrl: "https://assets.rurushishi.com/activies/activityCenter/lightup/default.png", type: "def" },
          { headImgUrl: "https://assets.rurushishi.com/activies/activityCenter/lightup/default.png", type: "def" },
        ];

        let site = {};
        let nextSite = null;

        data.map((item, index) => {
          let userList = this.userList.slice(requireLevel, requireLevel + 6);
          userList = userList.concat(defaultList);
          if (item.requireLevel <= this.assistanceNumber) {
            site = {
              ...item,
              index: index,
            };
          }
          if (!nextSite && item.requireLevel > this.assistanceNumber) {
            nextSite = {
              ...item,
              index: index,
            };
          }
          let obj = {
            ...JSON.parse(item.uiExt),
            ...item,
            index: index,
            require: item.requireLevel - requireLevel,
            // require:item.requireLevel-this.assistanceNumber,
            lackNum: item.requireLevel - this.assistanceNumber,
            userList: userList.slice(0, item.requireLevel - requireLevel>7?6:item.requireLevel - requireLevel),
          };
          requireLevel = item.requireLevel;
          list = [obj].concat(list);
        });

        console.log(list, site, nextSite);
        this.landmarkList = list;
        this.site = site;

        this.nextSite = nextSite;
        this.$nextTick(() => {
          this.handleScroll();
        });
        if (site.index == 0 && this.assistanceNumber == 0 && site.userLotteryCount == 0) {
          return;
        }
        if (!this.$util.cookie.get(`showHelp${site.id}`)) {
          this.alertFrom = setTimeout(() => {
            this.$modal.help
              .alert({
                assistanceNumber: this.assistanceNumber,
                currentInfo: site,
                nextInfo: nextSite,
                helpText: "助力值",
                animate: true,
              })
              .then((res) => {
                if (res == "goLuck") {
                  this.goLuck(site);
                }
              });
          }, 2000);

          this.$util.cookie.set(`showHelp${site.id}`, "1", {
            expires: (1 / 24) * (20 / 60 / 60),
          });
        }
      }
    },
    rgba(color, alp) {
      return util.rgbToRgba(color, alp);
    },
    handleScroll() {
      let top1 = document.getElementById("landmarkList").offsetTop;
      let top2 = document.getElementById("landmarkItem" + this.site.requireLevel).offsetTop;
      document.getElementById("boxMian").scrollTop = top2 + top1 - window.innerHeight / 2.5;
      let assistanceNumber = this.assistanceNumber;
      setTimeout(() => {
        console.log("声音播放");
        // 判断是否需要播放点亮声音
        let data = this.$luck.getData(this.$actCode);
        let num = 0;
        let requireLevel = -1;
        for (let i = this.landmarkList.length - 1; i >= 0; i--) {
          num += this.landmarkList[i].require;
          this.landmarkList[i].assistanceNumber = num;
        }

        for (let i = 0; i < this.landmarkList.length; i++) {
          console.log(`${this.landmarkList[i].assistanceNumber} >= ${assistanceNumber}`);
          if (assistanceNumber >= this.landmarkList[i].assistanceNumber) {
            requireLevel = this.landmarkList[i].requireLevel;
            break;
          }
        }
        console.log(`声音播放2,${requireLevel} > ${data.requireLevel}`);
        if (requireLevel >= data.requireLevel) {
          data.requireLevel = requireLevel;
          this.$luck.setData(this.$actCode, data);
          if (this.$configInfo.backgroundMusicSwitch && !this.$audio?.bg?.getIsPlay()) {
            if (!this.$audio.prize) {
              this.$audio.add("prize", "https://assets.rurushishi.com/activies/activityCenter/lightup/audio.mp3");
            }
            console.log("this.$audio.prize", this.$audio);
            this.$audio.prize.play({ loop: false }, () => {});
          }
        }
      }, 200);
    },
    async goLuck(item) {
      clearTimeout(this.alertFrom);
      if (item.index == 0 && item.lotteryTimesInit - item.userLotteryCount > 0) {
        item.userLotteryCount += 1;
        let url = this.$apizt.action.assistanceLottery.api + `${item.id}`;
        let { data, code } = await this.$httpzt.requestRestFul(url, {}, "post");
        if (code == 8884 || code == 500) {
          this.prizeInfo = {
            code: "thanks",
          };
        }
        if (code == 200) {
          this.prizeInfo = {
            ...data,
          };
        }
        console.log(this.prizeInfo);
        this.$modal.form
          .alert({
            type: this.prizeInfo.code == "thanks" ? "thanks" : "key",
            code: this.prizeInfo.prizeCode,
            prizeName: this.prizeInfo.prizeName,
            receiveKey: this.prizeInfo.receiveKey,
            prizeType: this.prizeInfo.prizeType,
            deadline: this.prizeInfo.deadline,
            category: 1,
            animate: true,
            siteIndex: item.index + 1,
            name: item.name,
          })
          .then((result) => {
            if (item.requireLevel == 0 && result == "success") {
              let data = this.$luck.getData(this.$actCode);
              data.redpacket = true;
              this.$luck.setData(this.$actCode, data);
            }
          });
        return;
      }
      this.$util.cookie.set("gameCount", item.lotteryTimesInit - item.userLotteryCount, {
        expires: 30,
      });
      console.log(this.$modal);
      this.$modal.luck
        .alert({
          animate: true,
          item: item,
        })
        .then((userLotteryCount) => {
          console.log("userLotteryCount", userLotteryCount);
          let cur = this.landmarkList.find((x) => x.id == item.id);
          cur.userLotteryCount = userLotteryCount;
        });
      // this.$router.push(`/luck?actCode=${this.$actCode}&id=${item.id}`);
    },
    showShare() {
      let text = {
        text1: "点击",
        text2: "右上角",
        text3: "推荐好友参与",
        text4: "让你和TA都获得金喜，",
        text5: "快去消息列表看看",
        text6: "会有什么神奇的事情发生吧！",
      };
      this.$modal.share.alert(text).then((data) => {
        if (data == "save") {
          console.log(this.configInfo.shareImg);
          this.$modal.poster.alert({
            gameBg: this.configInfo.shareImg, //分享截图背景图
          });
        }
      });
    },
    // 获取当前用户点亮值
    async getAssistanceNumber() {
      let url = this.$apizt.action.getAssistanceNumber;
      let { data, result } = await this.$httpzt.requestRestFul(url, {}, "get");
      if (result) {
        this.assistanceNumber = data;
      }
    },
    async getAssistanceUser() {
      let param = this.$apizt.action.getAssistanceUser;
      const { data, result } = await this.$httpzt.requestRestFul(param, {
        actCode: this.$actCode,
        size: 50,
        isAsc: true,
      });
      if (result) {
        console.log(data);
        this.userList = data.records;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  position: relative;
  box-sizing: border-box;

  img {
    width: 100%;
  }
}

.boxMian {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  .page-wrapper {
    position: relative;
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: 100% auto;
    padding-bottom: 130px;

    .kv {
      width: 375px;
      margin: 20px auto 0;
      text-align: center;
    }
    .landmarkList {
      width: 100%;
      .landmarkItem {
        position: relative;
        width: 375px;
        height: 150px;
        display: flex;
        align-items: flex-end;
        .icon {
          position: absolute;
          bottom: 0;
          left: 0;
        }
        .iconImg {
          animation: iconImg 3s ease;
        }
        @keyframes iconImg {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
        .buttonPosition {
          width: 50%;
          display: flex;
          flex-direction: column;
          align-items: center;
          .name {
            position: relative;
            background: rgba(83, 49, 223, 0.8);
            border-radius: 4px;
            padding: 6px 12px;
            text-align: center;
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            color: #ffffff;
            margin-bottom: 4px;
            .jt {
              position: absolute;
              background: rgba(83, 49, 223, 0.8);
              clip-path: polygon(0% 0, 100% 0%, 50% 100%);
              transition: 1s clip-path;
              width: 7px;
              height: 4px;
              left: 50%;
              top: 100%;
              transform: translateX(-50%);
            }
          }
          .success {
            position: relative;
            background: #4870ff;
            border: 1px solid rgba(255, 255, 255, 0.5);
            box-sizing: border-box;
            border-radius: 4px;
            padding: 0 8px;
            text-align: center;
            font-weight: 500;
            font-size: 12px;
            line-height: 24px;
            height: 24px;
            color: #ffffff;
          }
          .iconList {
            // padding:0 16px;
            margin-top: 0px;
            display: flex;
            align-items: center;
            .avatar {
              width: 32px;
              height: 32px;
              margin-left: -10px;
              border-radius: 32px;
              border: 1px solid #ffffff;
            }
            .def {
              border: none;
            }
            .avatar:first-child {
              margin-left: 0;
            }
          }
          .more {
            width: 32px;
            height: 32px;
            border: 1px solid #cad1db;
            box-sizing: border-box;
            border-radius: 56px;
            margin-left: -8px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #a3afbf;
            font-size: 20px;
          }
          .more2 {
            width: 32px;
            height: 32px;
            box-sizing: border-box;
            border-radius: 56px;
            margin-left: -8px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            font-size: 20px;
            border: 1px solid #ffffff;
            border-radius: 56px;
          }
        }
      }
    }
  }
  .prizeIcon {
    position: relative;
    width: 48px;
    height: 48px;
    margin-left: -18px;
    .anima {
      position: absolute;
      top: 8px;
      left: 8px;
      width: 32px;
      height: 32px;
      border-radius: 32px;
      background: rgba(250, 84, 28, 0.5);
      animation: anima 1s ease infinite;
    }
    @keyframes anima {
      0% {
        transform: scale(1);
      }
      100% {
        transform: scale(1.5);
      }
    }
  }
  .iconList div:first-child {
    margin-left: 0;
  }

  ::v-deep .btn_home {
    bottom: 48px;
    z-index: 101;
  }
}

.ActBaseBottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  /* height: 20px; */
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  line-height: 18px;
  z-index: 100;

  .default {
    width: 260px;
    height: 48px;
    margin-left: 24px;
    margin-bottom: 16px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 100px;
    text-align: center;
    line-height: 48px;
    font-size: 20px;
    font-weight: 600;
    animation: debounce 5s ease infinite;
  }
  .success {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #ffffff;
    .more-txt {
      font-weight: 500;
      font-size: 20px;
      line-height: 24px;
      margin-top: 10px;
      margin-bottom: 30px;
    }
  }
}

@keyframes debounce {
  0% {
    transform: rotate(-5deg);
  }
  4% {
    transform: rotate(5deg);
  }
  8% {
    transform: rotate(-5deg);
  }
  12% {
    transform: rotate(5deg);
  }
  16% {
    transform: rotate(-5deg);
  }
  20% {
    transform: rotate(5deg);
  }
  25% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(0);
  }
}
@keyframes tip_animate {
  from {
    transform: translateY(50px);
  }
  to {
    transform: translateY(-20px);
  }
}
@keyframes click_animate {
  0% {
    transform: rotate(-15deg);
  }
  40% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(15deg);
  }
}

.winsBox {
  width: 311px;
  height: 32px;
  border: 0.5px solid rgba(255, 255, 255, 0.2);
  box-sizing: border-box;
  box-shadow: 0px 0px 12px rgba(172, 3, 40, 0.3);
  border-radius: 12px;
  margin: 20px auto 0;
}

.tipImg {
  position: absolute;
  // bottom: 80px;
  left: 20px;
  width: 50px;
  top: 20px;
  pointer-events: none;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  &.animate-click {
    animation-name: click_animate;
    animation-timing-function: ease;
    animation-duration: 0.5;
  }
}

@keyframes click_animate {
  0% {
    transform: rotate(-15deg);
  }
  40% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(15deg);
  }
}
</style>
